import { render, staticRenderFns } from "./AdminOrderForm.vue?vue&type=template&id=1afc8837&scoped=true"
import script from "./AdminOrderForm.vue?vue&type=script&lang=js"
export * from "./AdminOrderForm.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderForm.vue?vue&type=style&index=0&id=1afc8837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc8837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
